import { render, staticRenderFns } from "./Groups.vue?vue&type=template&id=57450205"
import script from "./Groups.vue?vue&type=script&lang=js"
export * from "./Groups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57450205')) {
      api.createRecord('57450205', component.options)
    } else {
      api.reload('57450205', component.options)
    }
    module.hot.accept("./Groups.vue?vue&type=template&id=57450205", function () {
      api.rerender('57450205', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Admin/groups/Groups.vue"
export default component.exports